import { createContext, useContext, useEffect, useState } from "react";
import { clienteApi, setClienteToken } from "@/lib/api";

const ClienteAuthContext = createContext({ ctx: null, loading: true, refresh: async () => {}, logout: async () => {} });

export function ClienteAuthProvider({ children }) {
  const [ctx, setCtx] = useState(null); // {usuario, cliente}
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await clienteApi.get("/cliente-auth/me");
      setCtx(data);
      return data;
    } catch {
      setCtx(null);
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const logout = async () => {
    try { await clienteApi.post("/cliente-auth/logout"); } catch { /* ignore */ }
    setClienteToken(null);
    setCtx(null);
  };

  return (
    <ClienteAuthContext.Provider value={{ ctx, loading, refresh, logout }}>
      {children}
    </ClienteAuthContext.Provider>
  );
}

export const useClienteAuth = () => useContext(ClienteAuthContext);
